import css from 'styled-jsx/css';

export default css`.carousel {
  position: relative;
  background-position: center;
  background-size: cover;
  overflow: hidden; }
  .carousel a {
    color: unset; }
  .carousel :global(.sticky-inner-wrapper) {
    z-index: 1; }
  .carousel .carousel__slider {
    width: 100%;
    height: 100%; }
    .carousel .carousel__slider img {
      width: 100%; }
    .carousel .carousel__slider :global(.carousel__captions) {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;
      padding: 0 16px 16px;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      font-size: 16px;
      color: #fff; }
      .carousel .carousel__slider :global(.carousel__captions) :global(a) {
        color: #fff; }
      .carousel .carousel__slider :global(.carousel__captions) :global(.carousel__source) {
        cursor: pointer;
        float: left;
        flex: 1; }
      .carousel .carousel__slider :global(.carousel__captions) :global(.carousel__pagination) {
        float: right;
        height: auto; }
  .carousel .carousel__controlBox {
    position: absolute;
    width: 100%;
    max-width: 600px;
    height: 40px;
    z-index: 2;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(3, 3, 3, 0.4) 1%, rgba(176, 176, 176, 0.1) 69%, rgba(237, 237, 237, 0) 93%, rgba(255, 255, 255, 0) 100%); }
    .carousel .carousel__controlBox.active {
      background: #fff; }
      .carousel .carousel__controlBox.active .carousel__btn--backButton {
        background-image: url("https://static.popdaily.com.tw/img/icon/keyboard_arrow_left_black_72x72.png"); }
      .carousel .carousel__controlBox.active .carousel__btn--shareButton {
        background-image: url("https://static.popdaily.com.tw/img/icon/more_horiz_black_72x72.png"); }
      .carousel .carousel__controlBox.active .carousel__title {
        visibility: visible; }
  .carousel .carousel__btn {
    width: 40px;
    height: 40px;
    background-position: center;
    background-size: 25px;
    background-repeat: no-repeat;
    cursor: pointer; }
    .carousel .carousel__btn.carousel__btn--backButton {
      float: left;
      margin-left: 5px;
      background-image: url("https://static.popdaily.com.tw/img/icon/keyboard_arrow_left_white_72x72.png"); }
    .carousel .carousel__btn.carousel__btn--shareButton {
      float: right;
      margin-right: 5px;
      background-image: img("img/icon/more_horiz_white_72x72.png"); }
  .carousel .carousel__title {
    display: inline-block;
    padding: 0 10px;
    width: calc(100% - 90px);
    height: 40px;
    line-height: 40px;
    text-align: center;
    float: left;
    color: #666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    visibility: hidden;
    font-weight: 700; }
  .carousel .cover {
    height: 100vw;
    max-height: 600px;
    overflow: hidden;
    object-fit: contain; }

.ghost {
  padding-top: 0%;
  width: 100%;
  height: 144px; }

.ghost_banner {
  background-image: url("https://static.popdaily.com.tw/statics/images/map-ghost.jpg");
  height: 100%;
  background-size: cover;
  background-position: center; }
`